import { create } from 'zustand';

interface ProgressState {
  stage: string;
  step: string;
  current: number;
  percent: number;
  detail?: string;
}

interface EmailRefreshState {
  isRefreshing: boolean;
  progress: ProgressState | null;
  error: string | null;
  infoMessage: string | null;
  lastRefreshDate: string | null;
  
  // Actions
  startRefresh: () => void;
  updateProgress: (progress: ProgressState) => void;
  setError: (error: string) => void;
  setInfoMessage: (message: string) => void;
  setLastRefreshDate: (date: string) => void;
  cancelRefresh: () => void;
  reset: () => void;
}

export const useEmailRefreshStore = create<EmailRefreshState>((set) => ({
  isRefreshing: false,
  progress: null,
  error: null,
  infoMessage: null,
  lastRefreshDate: null,
  
  startRefresh: () => set({ 
    isRefreshing: true, 
    progress: null, 
    error: null, 
    infoMessage: null 
  }),
  
  updateProgress: (progress) => set({ progress }),
  
  setError: (error) => set({ 
    error, 
    isRefreshing: false 
  }),
  
  setInfoMessage: (message) => set({ 
    infoMessage: message, 
    isRefreshing: false 
  }),
  
  setLastRefreshDate: (date) => set({
    lastRefreshDate: date
  }),
  
  cancelRefresh: () => set({ 
    isRefreshing: false,
    infoMessage: 'Email refresh cancelled by user'
  }),
  
  reset: () => set({ 
    isRefreshing: false, 
    progress: null, 
    error: null, 
    infoMessage: null 
  }),
}));